import type { PivotRunState } from "../../viewer/storage/runState.ts";
import PivotContainer from "./PivotContainer";
import PivotViewer from "./PivotViewer";

interface Props {
  runState: PivotRunState;
}

export default function PivotViewerContainer({ runState }: Props) {
  return (
    <PivotContainer>
      <PivotViewer runState={runState} />
    </PivotContainer>
  );
}
